import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [status, setStatus] = useState(null); // null | 'loading' | 'success' | 'error'
  const [errorMsg, setErrorMsg] = useState('');

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('loading');
    setErrorMsg('');

    try {
      const res = await fetch(`${API_URL}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();

      if (res.ok && data.success) {
        setStatus('success');
        setForm({ name: '', email: '', phone: '', subject: '', message: '' });
      } else {
        setStatus('error');
        setErrorMsg(data.message || 'Bir hata oluştu, lütfen tekrar deneyin.');
      }
    } catch {
      setStatus('error');
      setErrorMsg('Sunucuya bağlanılamadı. Lütfen tekrar deneyin.');
    }
  }

  return (
    <section className="contact section-padding">
      <div className="container">
        <div className="row">
          {/* Bilgi Kutusu */}
          <div className="col-lg-4 valign">
            <div className="sec-head info-box full-width md-mb80">
              <div className="phone fz-30 fw-600 underline main-color">
                <a href="tel:+905393183852">+90 539 318 38 52</a>
              </div>
              <div className="morinfo mt-50 pb-30 bord-thin-bottom">
                <h6 className="mb-15">Çalışma Saatleri</h6>
                <p>Hafta içi / Hafta sonu 09:00 – 21:00</p>
              </div>
              <div className="morinfo mt-30 pb-30 bord-thin-bottom">
                <h6 className="mb-15">E-posta</h6>
                <p>
                  <a href="mailto:kanusdigital@gmail.com">kanusdigital@gmail.com</a>
                </p>
              </div>
              <div className="social-icon mt-50">
                <a href="https://www.instagram.com/kanusdigital/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://www.tiktok.com/@kanusdigital" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-tiktok"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="col-lg-7 offset-lg-1 valign">
            <div className="full-width">
              <div className="sec-head mb-50">
                <h6 className="sub-title main-color mb-15">Hadi Konuşalım</h6>
                <h3 className="text-u ls1">
                  Bize <span className="fw-200">Mesaj Gönderin</span>
                </h3>
              </div>

              {/* Başarı Mesajı */}
              {status === 'success' && (
                <div
                  style={{
                    background: 'rgba(39,174,96,0.12)',
                    border: '1px solid #27ae60',
                    borderRadius: '12px',
                    padding: '24px 30px',
                    marginBottom: '30px',
                    textAlign: 'center',
                  }}
                >
                  <div style={{ fontSize: '40px', marginBottom: '10px' }}>✓</div>
                  <h5 style={{ color: '#27ae60', marginBottom: '8px' }}>Mesajınız Gönderildi!</h5>
                  <p style={{ color: '#ccc', margin: 0 }}>
                    En kısa sürede size dönüş yapacağız.
                  </p>
                  <button
                    onClick={() => setStatus(null)}
                    style={{
                      marginTop: '16px',
                      background: 'transparent',
                      border: '1px solid #27ae60',
                      color: '#27ae60',
                      borderRadius: '30px',
                      padding: '8px 24px',
                      cursor: 'pointer',
                    }}
                  >
                    Yeni Mesaj Gönder
                  </button>
                </div>
              )}

              {/* Hata Mesajı */}
              {status === 'error' && (
                <div
                  style={{
                    background: 'rgba(231,76,60,0.12)',
                    border: '1px solid #e74c3c',
                    borderRadius: '12px',
                    padding: '16px 20px',
                    marginBottom: '20px',
                    color: '#e74c3c',
                  }}
                >
                  {errorMsg}
                </div>
              )}

              {/* Form - başarıda gizle */}
              {status !== 'success' && (
                <form id="contact-form" className="form2" onSubmit={handleSubmit}>
                  <div className="controls row">
                    <div className="col-lg-6">
                      <div className="form-group mb-30">
                        <input
                          id="form_name"
                          type="text"
                          name="name"
                          placeholder="Adınız Soyadınız"
                          required
                          value={form.name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group mb-30">
                        <input
                          id="form_email"
                          type="email"
                          name="email"
                          placeholder="E-posta Adresiniz"
                          required
                          value={form.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group mb-30">
                        <input
                          id="form_phone"
                          type="tel"
                          name="phone"
                          placeholder="Telefon Numaranız"
                          value={form.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group mb-30">
                        <input
                          id="form_subject"
                          type="text"
                          name="subject"
                          placeholder="Konu"
                          value={form.subject}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <textarea
                          id="form_message"
                          name="message"
                          placeholder="Mesajınız"
                          rows="4"
                          required
                          value={form.message}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                      <div className="mt-30">
                        <button
                          type="submit"
                          className="butn butn-full butn-bord radius-30"
                          disabled={status === 'loading'}
                        >
                          <span className="text">
                            {status === 'loading' ? 'Gönderiliyor...' : 'Mesaj Gönder'}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
